import { Box } from '@bonanza-social/moonlight';
import { RewardCardType } from './RewardCard.types';
import { useMemo } from 'react';
import ReferrerContent from './ReferrerContent/ReferrerContent';
import { Promotion } from '../../../services/RegistrationOffersService/RegistrationOffersService.schemas';
import RegistrationOfferImage from '../../RegistrationOfferImage/RegistrationOfferImage';
import WelcomeContent from './WelcomeContent/WelcomeContent';

function RewardCard({
  type,
  promotion,
}: {
  type: RewardCardType;
  promotion: Promotion;
}) {
  const ContentComponent = useMemo(() => {
    if (type === RewardCardType.REFERRER) {
      return ReferrerContent;
    }

    return WelcomeContent;
  }, [type]);

  return (
    <Box
      backgroundColor="secondaryBackgroundDefault"
      flexDirection="row"
      alignItems="center"
      borderRadius="radius-200"
    >
      <RegistrationOfferImage
        width={60}
        height={60}
        rewards={promotion.rewards}
        miniImageUrl={promotion?.miniImageUrl || ''}
      />
      <ContentComponent promotion={promotion} />
    </Box>
  );
}

export default RewardCard;
